import { render } from "./FooterLayer.vue?vue&type=template&id=ce57b01a&scoped=true"
const script = {}

import "./FooterLayer.vue?vue&type=style&index=0&id=ce57b01a&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce57b01a"]])

export default __exports__